import React, {PropTypes} from 'react';
import Panel from 'shared/Panel.jsx';
import Link from 'shared/Link.jsx';
import TournamentEntryContainer from './TournamentEntryContainer.jsx';
import CaptainBalanceDetailContainer from './CaptainBalanceDetailContainer.jsx';
import CaptainEntryOptionsContainer from './CaptainEntryOptionsContainer.jsx';
import CaptainDetailPaymentModalContainer from './CaptainDetailPaymentModalContainer.jsx';
import CaptainDetailNotesContainer from './CaptainDetailNotesContainer.jsx';
import CaptainDetailNotesModalContainer from './CaptainDetailNotesModalContainer.jsx';
import CaptainDetailUpdateModalContainer from './CaptainDetailUpdateModalContainer.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';

const CaptainDetail = ({
  captainName,
  captainEmail,
  captainAddress1,
  captainAddress2,
  captainCity,
  captainState,
  captainCountry,
  captainZip,
  captainPhoneNumber,
  showSearchLink,
  loadingTournaments,
  tournamentEntries,
  onUpdateClicked,
  hideCancelledEntries,
  hideArchivedEntries,
  onHideCancelledEntriesChange,
  onHideArchivedEntriesChange 
}) => (
  <div className="animated fadeIn">
    <CaptainDetailPaymentModalContainer />
    {showSearchLink
      ? <div className="row">
          <div className="col-md-12">
            <Link
              className="btn btn-link"
              style={{paddingLeft: 0}}
              to="admin/search">
              {'Back to search results'}
            </Link>
          </div>
        </div>
    : null
    }
    <div className="row">
      <div className="col-md-6 col-xs-12">
        <CaptainDetailUpdateModalContainer />
        <Panel className="panel-primary"
          style={{minHeight: 200}}
          title={<span>{captainName} <small>(TC)</small></span>}>
          <h5>{'Contact'}</h5>
          <div>{captainEmail}</div>
          <DisplayIf condition={!!captainAddress1}>{captainAddress1}</DisplayIf>
          <DisplayIf condition={!!captainAddress2}>{captainAddress2}</DisplayIf>
          <DisplayIf condition={!!captainCity || !!captainState || !!captainCountry || !!captainZip}>
              {captainCity} {captainState} {captainCountry} {captainZip}
          </DisplayIf>
          <DisplayIf condition={!!captainPhoneNumber}>{captainPhoneNumber}</DisplayIf>
          <div className="flex right">
            <button
              type="button"
              className="btn btn-link"
              onClick={() => onUpdateClicked()}>
                {'Update Name'}
            </button>
          </div>
        </Panel>
      </div>
      <div className="col-md-6 col-xs-12">
        <CaptainDetailNotesContainer />
        <CaptainDetailNotesModalContainer />
      </div>
      <div className="col-md-12">
        <CaptainBalanceDetailContainer />
      </div>
      <div className="col-md-12">
        <CaptainEntryOptionsContainer />
      </div>
    </div>
    <div className="custom-checkbox-container"
      style={{margin: '1px 1px', display:'inline-block'}}>
      <input type="checkbox"
        id="hideCancelled" 
        disabled={loadingTournaments}
        checked={hideCancelledEntries}
        onChange={event => onHideCancelledEntriesChange(event.target.checked)}/>
      <label htmlFor="hideCancelled">{'Hide Cancelled Entries'}</label>
    </div>
    <div className="custom-checkbox-container"
      style={{margin: '1px 1px', display:'inline-block', paddingLeft:'10px'}}>
      <input type="checkbox"
        id="hideArchived" 
        disabled={loadingTournaments}
        checked={hideArchivedEntries}
        onChange={event => onHideArchivedEntriesChange(event.target.checked)}/>
      <label htmlFor="hideArchived">{'Hide Archived Entries'}</label>
    </div>
    { loadingTournaments ? 
      <div className="alert alert-info text-center" 
           style={{margin: '16px 0px'}}>{'Loading entries'}</div> : 
    <div className="row"> 
      {tournamentEntries.map((item, index) => (
        <div className="col-md-12"
          key={index}>
          <TournamentEntryContainer {...item} />
        </div>
      ))}
    </div>
  }
  </div>
);

CaptainDetail.defaultProps = {
  captainName: '',
  captainEmail: '',
  captainAddress1: '',
  captainAddress2: '',
  captainCity: '',
  captainState: '',
  captainCountry: '',
  captainZip: '',
  captainPhoneNumber: '',
  showSearchLink: false,
  loadingTournaments: false,
  tournamentEntries: []
};

CaptainDetail.propTypes = {
  captainName: PropTypes.string,
  captainEmail: PropTypes.string,
  captainAddress1: PropTypes.string,
  captainAddress2: PropTypes.string,
  captainCity: PropTypes.string,
  captainState: PropTypes.string,
  captainCountry: PropTypes.string,
  captainZip: PropTypes.string,
  captainPhoneNumber: PropTypes.string,
  showSearchLink: PropTypes.bool,
  loadingTournaments: PropTypes.bool,
  tournamentEntries: PropTypes.arrayOf(PropTypes.object),
  onUpdateClicked: PropTypes.func,
  hideCancelledEntries: PropTypes.bool,
  onHideCancelledEntriesChange: PropTypes.func,
  hideArchivedEntries: PropTypes.bool,
  onHideArchivedEntriesChange: PropTypes.func
};

export default CaptainDetail;



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/CaptainDetail.jsx